export default "__VITE_ASSET__BzqsxTZA__"